"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentLifecycle = void 0;
/**
 * Class representing the lifecycle status of a Content Item with helper functions.
 */
var ContentLifecycle = /** @class */ (function () {
    /**
     * Creates a new ContentLifecycle instance.
     * @param data JSON representation of the ContentLifecycle model
     */
    function ContentLifecycle(data) {
        if (data) {
            Object.assign(this, data);
        }
    }
    /**
     * Returns a boolean to indicate if the content should no longer be displayed by your application.
     * @param currentTime Optional date to override the current time.
     */
    ContentLifecycle.prototype.isExpired = function (currentTime) {
        currentTime = currentTime || new Date();
        return (this.expiryTime !== undefined &&
            new Date(this.expiryTime).getTime() < currentTime.getTime());
    };
    /**
     * Export to JSON
     */
    ContentLifecycle.prototype.toJSON = function () {
        return {
            expiryTime: this.expiryTime,
        };
    };
    return ContentLifecycle;
}());
exports.ContentLifecycle = ContentLifecycle;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudExpZmVjeWNsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvY29udGVudC9tb2RlbC9Db250ZW50TGlmZWN5Y2xlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBOztHQUVHO0FBQ0g7SUFRRTs7O09BR0c7SUFDSCwwQkFBWSxJQUFVO1FBQ3BCLElBQUksSUFBSSxFQUFFO1lBQ1IsTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUM7U0FDM0I7SUFDSCxDQUFDO0lBRUQ7OztPQUdHO0lBQ0gsb0NBQVMsR0FBVCxVQUFVLFdBQWtCO1FBQzFCLFdBQVcsR0FBRyxXQUFXLElBQUksSUFBSSxJQUFJLEVBQUUsQ0FBQztRQUN4QyxPQUFPLENBQ0wsSUFBSSxDQUFDLFVBQVUsS0FBSyxTQUFTO1lBQzdCLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsQ0FBQyxPQUFPLEVBQUUsR0FBRyxXQUFXLENBQUMsT0FBTyxFQUFFLENBQzVELENBQUM7SUFDSixDQUFDO0lBRUQ7O09BRUc7SUFDSCxpQ0FBTSxHQUFOO1FBQ0UsT0FBTztZQUNMLFVBQVUsRUFBRSxJQUFJLENBQUMsVUFBVTtTQUM1QixDQUFDO0lBQ0osQ0FBQztJQUNILHVCQUFDO0FBQUQsQ0FBQyxBQXRDRCxJQXNDQztBQXRDWSw0Q0FBZ0IifQ==